import { useEffect, useState } from 'react';
import { STATIC_AI_STATUS_TYPES } from '../constants/constants.js';
import './styles/ImageAndVideoComponent.scss';

const ImageAndVideoComponent = ({ pair, index }) => {
  const [fixTitle, setFixTitle] = useState('');
  const [fixstatus, setFixstatus] = useState();
  const [paintedTitle, setPaintedTitle] = useState('');
  const [paintedstatus, setPaintedstatus] = useState();

  useEffect(() => {
    if (pair.image_dynamic_AI === false) {
      setFixTitle('未选择AI动态化, 无AI修复');
      setPaintedTitle('未选择AI动态化, 无AI扩图');
    } else {
      setFixTitle('AI修复');
      setPaintedTitle('AI扩图');
      setFixstatus(pair.fix_status);
      setPaintedstatus(pair.painted_status);
    }
  }, [pair]);

  return (
    <>
      <div key={index} className="image-video-pair">
        <div className="image-container">
          <div className="image-video-pair-title">图片</div>
          <div className="image-video-pair-image">
            <img src={pair.image_url} alt="图片" />
          </div>
        </div>

        <div className="image-container">
          <div className="image-video-pair-title">{fixTitle}</div>
          {fixstatus === STATIC_AI_STATUS_TYPES.FAILED ? (
            <div>{`失败: ${pair.fix_error}`}</div>
          ) : pair.image_dynamic_AI === false ? null : (
            <div className="image-video-pair-image">
              <img src={pair.fix_url} alt="图片" />
            </div>
          )}
        </div>
        <div className="image-container">
          <div className="image-video-pair-title">{paintedTitle}</div>
          {paintedstatus === STATIC_AI_STATUS_TYPES.FAILED ? (
            <div>{`失败: ${pair.painted_error_message}`}</div>
          ) : pair.image_dynamic_AI === false ? null : (
            <div className="image-video-pair-image">
              <img src={pair.painted_image_url} alt="图片" />
            </div>
          )}
        </div>

        {/* {pair.kling_video_url === null ? (
          pair.painted_status === STATIC_AI_STATUS_TYPES.FAILED ? (
            <>
              <div className="image-container">
                <div className="image-video-pair-title">扩图失败</div>
                <div className="image-video-pair-image">
                  {pair.painted_error_message}
                </div>
              </div>
            </>
          ) : (
            <div className="image-container">
              <div className="image-video-pair-title">扩图后的图片</div>
              <div className="image-video-pair-image">
                <img src={pair.painted_image_url} alt="图片" />
              </div>
            </div>
          )
        ) : pair.kling_status !== KLING_STATUS_TYPES.SUCCEED ? (
          <div className="video-container">
            <div className="image-video-pair-title">视频生成失败</div>
            <div className="image-video-pair-video">
              {' '}
              {pair.kling_error_message}
            </div>
          </div>
        ) : (
          <div className="video-container">
            <div className="image-video-pair-title">视频</div>
            <div className="image-video-pair-video">
              <video controls>
                <source src={pair.kling_video_url} type="video/mp4" />
                您的浏览器不支持视频元素。
              </video>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};

export default ImageAndVideoComponent;
